/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/upgrades/UpgradeBase'
], (UpgradeBase) => {

	/* adds template indicator to the tab/scene if it has no template or indicator*/
	class LayoutTemplateIndicatorUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 1023;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec || !spec.layout) {
				return Promise.resolve(spec);
			}
			(spec.layout.items || []).forEach(pageContainers => {
				(pageContainers.items || []).forEach(page => {
					this._upgradePage(page);
				});
			});
			return Promise.resolve(spec);
		}

		_upgradePage(page) {
			if( !page || page.type !== 'genericPage'){
				return;
			}
			page.items = page.items || [];
			let hasIndicatorOrTemplate = !!page.items.find(item => item.type === 'templateDropZone' || item.type === 'templateIndicator');
			if( !hasIndicatorOrTemplate ) {
				page.items.unshift({
					'style': {
						'top': '0%',
						'left': '0%',
						'right': '0%',
						'bottom': '0%'
					},
					'type': 'templateIndicator'
				});
			}
		}
	}
	return new LayoutTemplateIndicatorUpgrade();
});
